import UploadPage from "./UploadPage";

// Re-export current upload UI for onboarding routing.
export default function OnboardingUploadPage() {
  return <UploadPage />;
}

